import ImageUpload from "./imageUploadComponent";

export default ImageUpload;